import { JSX } from 'react';
import { Navigate } from 'react-router-dom';

import { LOGIN_PATH } from '../../config/paths';
import { useSession } from '../../context/use-session';

export interface Props {
  loader: JSX.Element | JSX.Element[];
  children: JSX.Element | JSX.Element[];
}

const Protected = ({ loader, children }: Props) => {
  const { isLoggedIn, isLoading } = useSession();

  if (isLoading) {
    return <>{loader}</>;
  }

  if (!isLoggedIn) {
    return <Navigate to={LOGIN_PATH} replace />;
  }

  return <>{children}</>;
};

export default Protected;
